import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-timesheets',
  templateUrl: './timesheets.component.html',
  styles: []
})
export class TimesheetsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
